//import Model from "@/models/Model";
//import Customer from "@/models/Customer";

class Order {
    static fromArray(data) {
        let order = new Order()

        order.order_id = data.orderid
        order.customer_id = data.customer_id

        order.title = data.title
        order.firstname = data.firstname
        order.surname = data.surname

        order.datedue = data.datedue

        order.blue_bag = !!parseInt(data.hasBlueBag)

        return order
    }

    static fromExtendedArray(data) {
        let order = Order.fromArray(data)
        order.first_order = data.first_order
        order._fromExtended = true
        return order
    }

    _fromExtended = false

   // setCustomer(Customer) {}

    setServiceTickets(tickets) {
        this._ticketsRequested = new Promise(resolve => {
            resolve(tickets)
        })
    }

    getCustomerName() {
        return `${this.firstname} ${this.surname}`
    }

    getServiceTickets() {
        if (this._ticketsRequested) return this._ticketsRequested

        return (this._ticketsRequested = new Promise((resolve, reject) => {}))
    }

    toString() {
        return (
            "Order " +
            this.order_id +
            (this._fromExtended ? " (from extended array)" : "")
        )
    }
}

export default new Order();